// extracted by mini-css-extract-plugin
export default {"supplierHeaderRow":"app-chat_supplierHeaderRow__2o9vw"};